import moment from "moment";
export default {
  id: "vatSettlement",
  text: "Liquidazione IVA",
  detailParams: ["journalType", "vatCode"],
  mainParams: ["refYear", "periodRef"],
  header: {
    rows: [
      {
        type: "row",
        items: [
          {
            type: "dropdown",
            id: "refYear",
            label: "Anno di riferimento",
            range: { min: moment().format("YYYY"), max: moment().subtract(10, "years").format("YYYY") },
            initValue: moment().format("YYYY")
          },
          {
            type: "dropdown",
            id: "periodRef",
            label: "Periodo",
            values: [
              { label: "Gennaio", value: "JANUARY" },
              { label: "Febbraio", value: "FEBRUARY" },
              { label: "Marzo", value: "MARCH" },
              { label: "Aprile", value: "APRIL" },
              { label: "Maggio", value: "MAY" },
              { label: "Giugno", value: "JUNE" },
              { label: "Luglio", value: "JULY" },
              { label: "Agosto", value: "AUGUST" },
              { label: "Settembre", value: "SEPTEMBER" },
              { label: "Ottobre", value: "OCTOBER" },
              { label: "Novembre", value: "NOVEMBER" },
              { label: "Dicembre", value: "DECEMBER" },
              { label: "Primo trimestre", value: "FIRST_QUARTER" },
              { label: "Secondo trimestre", value: "SECOND_QUARTER" },
              { label: "Terzo trimestre", value: "THIRD_QUARTER" },
              { label: "Quarto trimestre", value: "FOURTH_QUARTER" },
              { label: "Annuale", value: "ANNUAL" }
            ],
            initValue: "JANUARY"
          }
        ]
      },
      {
        type: "col",
        items: [
          /* {
            type: "checkbox",
            id: "includeRegistrations",
            label: "Includi registrazioni non contabilizzate",
            initValue: false
          },
          {
            type: "checkbox",
            id: "excludeRegistrationsNotReportedInPreviousPeriod",
            label: "Escludi le registrazioni non riportate dai periodi precedenti",
            initValue: false
          }*/
        ]
      }
    ]
  }
};
